import { useMutation } from '@tanstack/react-query';
import { IAddOfferResponse, IEditReferral } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const deleteReferralOffer = async (id: string, body?: IEditReferral) => {
  const res = await apiManager.delete<IAddOfferResponse>(
    `/referral-offer/${id}/delete`,
    body
  );
  return res;
};

export const useDeleteReferralOffer = () =>
  useMutation({
    mutationFn: async (id: string) => {
      const res = await apiClient.delete(ENDPOINTS.REFERRAL_OFFERS.DELETE_REFERRAL_OFFER(id));
      return res.data;
    },
  });